import React from "react";
import { Box, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Functionality from "../../../widgets/supervisor/operator-details/FunctionalityOperator";
import Layout from "../Layout";
import ProfileBanner from "../../../widgets/supervisor/operator-details/ProfileBanner";
import ProfileFormDetails from "../../../widgets/supervisor/operator-details/ProfileFormDetails";
import AvailableCRMOperator from "../../../widgets/supervisor/operator-details/AvailableCRMOperator";
import OperatorTableContainer from "../../../widgets/supervisor/operator-details/OperatorTable";
// import OperatorDetailsTable from "../../../widgets/supervisor/operator-details/OperatorDetails";
function OperatorDetails(props) {
  const navigate = useNavigate();

  const refreshList = () => {
    console.log("Обновление списка после удаления");
  };
  return (
    <Layout>
      <Grid sx={{ mb: 2 }} size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 7 }}>
        <ProfileBanner
          onDeleted={refreshList}
          redirectPath="/supervisor/operators"
        />
      </Grid>
      <Grid sx={{ mb: 2 }} size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 7 }}>
        <ProfileFormDetails />
      </Grid>
      <Grid sx={{ mb: 2 }} size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 7 }}>
        <OperatorTableContainer />
      </Grid>
      <Grid sx={{ mb: 2 }} size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 7 }}>
        {/* <Box sx={{ display: "flex", gap: 2 }}>
          <AvailableCRMOperator />
          <Functionality />
        </Box> */}
      </Grid>
    </Layout>
  );
}

export default OperatorDetails;
